// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketplaceReleaseSection_container__XYuTz","bottomLeftEllipse":"MarketplaceReleaseSection_bottomLeftEllipse__1tNHO","title":"MarketplaceReleaseSection_title__W78g7"};